import React, { Component } from 'react';
import { PROMO_URLS } from '../helpers/api/API_URLS';
import { basicGET, basicJSONPOST } from '../helpers/api/fetchParams';

import { SearchForm } from '../helpers/uiComponents/Search';
import { Reload } from '../helpers/uiComponents/Reload';
import { CheckClientPromos } from './Explorer/CheckClientPromos';
import { ActionTabs } from '../helpers/uiComponents/ActionTabs';
import { CloseProfile } from '../helpers/uiComponents/CloseProfile';
import { ResultList } from '../helpers/uiComponents/ResultList';
import { InputRow } from '../helpers/uiComponents/InputRow';

import { getAllPromotions, getPromotionById } from '../data/servicePromotions';

import { accordian, hideMessage, hidePopup, showMessage, showPopup, toggleStatus } from '../helpers/uiFunctions/uiActions';
import AccordianTitle from '../helpers/uiComponents/Accordian';
import { franchiseList, promoFloorToCeilingFormList, promoVelocityFormList } from '../helpers/uiFunctions/uiHelpers';
import ClientAssignmentList from '../helpers/uiComponents/ClientAssignmentList';
import NewPromotionForm from './Explorer/NewPromo';
import DuplicatePromoForm from './Explorer/DupePromo';

function removeA(arr) {
    var what, a = arguments, L = a.length, ax;
    while (L > 1 && arr.length) {
        what = a[--L];
        while ((ax= arr.indexOf(what)) !== -1) {
            arr.splice(ax, 1);
        }
    }
    return arr;
}

class Promotions extends Component {
	constructor(props) {
		super(props);
		this.state = {
			promos: [],
			currentPromo: [],
			currentWidgets: [],
			clients: [],
			clientList: [],
			promoReport: [],
			couponTemplates: [],
		}
		this.load = this.load.bind(this);
		this.loadPromotions = this.loadPromotions.bind(this);
		this.promoDuplicate = this.promoDuplicate.bind(this);
		this.saveConfig = this.saveConfig.bind(this);
		this.saveWidget = this.saveWidget.bind(this);
		this.getPromoReport = this.getPromoReport.bind(this);
	}
	componentDidMount() {
		this.loadPromotions();
	}
	componentDidUpdate(prevProps) {
		try {
			if( this.props.clients && (this.props.clients !== prevProps.clients )) {
				var activeClients = this.props.clients.filter( client => { return client.status === "active"; });
				let list = this.state.clientList;
				for (var i = 0; i < activeClients.length; i++) {
					list.push({"name": activeClients[i].name, "value": activeClients[i].clientCode,},)
				}
				
				this.setState({
					clients: activeClients,
					allClients: activeClients,
					clientList: list,
				});
			}

			if( this.props.sgTemplates && (this.props.sgTemplates !== prevProps.sgTemplates )) {
				//console.log("update client list");
				this.setState({
					couponTemplates: this.props.sgTemplates,
				});
			}
		} catch (error) {
			console.log(error);
		}
	}
	loadPromotions() {
		getAllPromotions().then(promotions => {
			var coupons = promotions.filter( prom => { return prom.promoType === "coupon"; });
				coupons = coupons.sort((a, b) => b.promoId - a.promoId);

			this.setState({
				promos: coupons,
			});
		})
	}
	load(newId) {
		console.log("loading promotion: "+newId);
		let id = this.state.currentPromo.promoId;
		if (newId) {id = newId;}

		getPromotionById(id).then(promotion => {
			var widgetList = promotion.result.widgets
			for (let index = 0; index < widgetList.length; index++) {
				widgetList[index]["id"] = widgetList[index]["widgetId"];
			}
			// if (promotion.result.franchiseName) {
				var franchiseName = promotion.result.franchiseName;
				if (franchiseName === "No") {
					franchiseName = null;
				}
				var clients = this.state.allClients;
				// console.log(franchiseName);
				// console.log(clients);
				var newList = clients.filter( client => { return client.franchiseName === franchiseName; });
			// }
			this.setState({ 
				currentPromo: promotion.result, 
				currentWidgets: widgetList,
				clients: newList,
			});
		}).then(() => {
			document.querySelectorAll("#promotion-profile-column .profile")[0].style.display = "block";
		})
	}
	resetProfile() {
		this.setState({
			currentPromo: [],
			currentWidgets: []
		});
	}
	addPromotion(promoName, promoStart, promoEnd) {
		showMessage("Adding Promotion...");

		let token = localStorage.getItem("token");

		let name = document.getElementById(promoName).value;
		let start = document.getElementById(promoStart).value;
		let end = document.getElementById(promoEnd).value;

		var body = {
			"name": name,
			"startDate": start,
			"endDate": end,
			"promoType": "coupon",
		}

		fetch(PROMO_URLS.promo, basicJSONPOST(token, body))
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('Something went wrong ...'); }
		})
		.then(data => {
			hideMessage(data.success);
			if (data.success) {
				this.loadPromotions();
				this.load(data.result.promoId);
				hidePopup('addPromoForm');
			}
		})
		.catch(error => console.log(error));
	}
	addWidget(widgetType) {
		let token = localStorage.getItem("token");
		showMessage("Adding Widget...");
		var paramsBody = {
			"promoId": this.state.currentPromo.promoId,
			"type": widgetType,
			"name": "New "+widgetType,
		}
		var postParams = {
			headers: {
				"authorization": "Bearer " + token,
				"Accept" : "application/json",
				"Content-Type": "application/json",
			},
			body: JSON.stringify(paramsBody),
			method: "POST",
		}
		//console.log(postParams);
		fetch(PROMO_URLS.widget, postParams)
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('Something went wrong ...'); }
		})
		.then(data => {
			hideMessage(data.success);
			this.load();
		})
		.catch(error => console.log(error));
	}
	promoDuplicate() {
		let token = localStorage.getItem("token");
		showMessage("Duplicating the promotion...");
		var strconfirm = window.confirm("Are you sure you want to duplicate the Promotion?");
		if (strconfirm !== true) {
			return;
		}

		let promo = this.state.currentPromo;
		// remove the promo identifiers
		delete promo.promoId;
		delete promo.promoCode;
		// reset the name and dates
		var name = document.getElementById("dupePromoName").value;
		var start = document.getElementById("dupePromoStart").value;
		var end = document.getElementById("dupePromoEnd").value;
		promo.name = name;
		promo.startDate = start;
		promo.endDate = end;

		// reset the widget IDs
		for (var i = 0; i < promo.widgets.length; i++) {
			delete promo.widgets[i].widgetId;
			delete promo.widgets[i].promoId;
			delete promo.widgets[i].images;
			delete promo.widgets[i].texts;
		}
		var dupeParams = {
			headers: {
				"authorization": "Bearer " + token,
				"Accept" : "application/json",
				"Content-Type": "application/json",
			},
			body: JSON.stringify(promo),
			method: "POST",
		}
		fetch(PROMO_URLS.promo, dupeParams)
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('Something went wrong ...'); }
		})
		.then(data => {
			hideMessage(data.success);
			if (data.success) {
				hidePopup("dupePromoForm");
				this.resetProfile();
				this.load(data.result.promoId);
			} else {
				alert("Make sure the Promo Name is unique. If it is, something else went wrong..");
			}
		})
		.catch(error => console.log(error));
	}
	assign(clientCode, clientList, widget) {
		let token = localStorage.getItem("token");

		var promoBody = widget;
		if (!clientList.includes(clientCode)) {
			clientList.push(clientCode);
		} else {
			removeA(clientList, clientCode);
		}

		promoBody["clientCodes"] = clientList;

		var params = {
			headers: {
				"authorization": "Bearer " + token,
				"Content-Type": "application/json",
			},
			body: JSON.stringify(promoBody),
			method: "POST",
		}

		fetch(PROMO_URLS.API+"widget", params)
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('Something went wrong ...'); }
		})
		.then(data => {
			var input = document.querySelector('#'+widget.type+'-'+clientCode)
			var checked = input.checked;
			// console.log(checked);
			if (checked) {
				input.checked = false;
			} else {
				input.checked = true;
			}

		})
		.catch(error => console.log(error));
	}
	
	saveWidget(action, widgetType) {
		if (action === "delete") {
			var strconfirm = window.confirm("Are you sure you want to delete?");
			if (strconfirm !== true) { return; }
		} else {
			showMessage("Saving Widget...");
		}

		var widgetBody = {};
		var hiddenInputs, inputs, saveType, postMethod, widgetId, i;
		if (widgetType !== "info") {
			widgetId = document.querySelectorAll("#promo-"+widgetType+"-inputs .tab.active > input[name='widgetId']")[0].value;
			widgetId = parseInt(widgetId, 10);
		}
		if (widgetType === "email") {
			var widget = this.state.currentWidgets.filter(widget => {
				return widget.widgetId === widgetId;
			})
			var events = widget[0].events;
			widgetBody["events"] = events;
		}
		if (widgetType === "message" || widgetType === "navigation" || widgetType === "landing" ||  widgetType === "thanks") {
			inputs = document.querySelectorAll("#promo-"+widgetType+"-inputs .tab.active > .texts-container > .texts-"+widgetId);
			var texts = [];
			
			for (i = inputs.length - 1; i >= 0; i--) {
				var txtId = "";
				var type = inputs[i].querySelector("[name='type']").value;
				var txt = inputs[i].querySelector("textarea[name='text']").value;
				if (inputs[i].querySelector("[name='textId']")) {
					txtId = inputs[i].querySelector("[name='textId']").value;
				}
				texts.push( {"text": txt, "type": type, "textId": txtId, "widgetId": widgetId,}, )
			}
			widgetBody["texts"] = texts;
		}

		if (action === "delete") {
			postMethod = "DELETE"; saveType = "widget"; widgetBody["widgetId"] = widgetId;
		} else {
			postMethod = "POST";
			
			if (widgetType !== "info") {
				hiddenInputs = document.querySelectorAll("#promo-"+widgetType+"-inputs .tab.active > input");
				inputs = document.querySelectorAll("#promo-"+widgetType+"-inputs .tab.active > .input-row input");
				saveType = "widget";

				for (i = hiddenInputs.length - 1; i >= 0; i--) {
					widgetBody[hiddenInputs[i].name] = hiddenInputs[i].value;
				}
				for (i = inputs.length - 1; i >= 0; i--) {
					if (inputs[i].type === "checkbox") {
						widgetBody[inputs[i].name] = inputs[i].checked;
					} else {
						widgetBody[inputs[i].name] = inputs[i].value;
					}
				}
			}
			
			var update = this.state.currentWidgets
			console.log(widgetId);

			for (i = update.length - 1; i >= 0; i--) {
				// console.log(update[i].widgetId);

				if ( update[i].widgetId === parseInt(widgetId, 10) ) {
					var images = update[i].images;
					// console.log(images);
					
					widgetBody["images"] = images;
				}
			}

		}
		let token = localStorage.getItem("token");

		var widgetParams = {
			headers: {
				"authorization": "Bearer " + token,
				"Content-Type": "application/json",
			},
			body: JSON.stringify(widgetBody),
			method: postMethod,
		}
		// console.log(widgetBody)
		fetch(PROMO_URLS.API+saveType, widgetParams)
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('Something went wrong ...'); }
		})
		.then(response => {
			hideMessage(response.success);
			this.load();
		})
		.catch(error => console.log(error));
	}
	handleEvent(action, widgetId, index) {
		var update = this.state.currentWidgets
		for (var i = update.length - 1; i >= 0; i--) {
			if ( update[i].widgetId === widgetId ) {
				if (action === "remove") {
					update[i].events.splice(index, 1);
				} else {
					update[i].events.push(
						{
							"days": 0,
							"hours": 0,
							"template": null
						},
					);
				}
			}
		}
		this.setState({currentWidgets: update});
	}
	updateConfigState(key, value) {
		console.log(key, value);
		if (value === "Select..." || value === "null") {
			value = null;
		}
		var update = this.state.currentPromo;
		update[key] = value;
		this.setState({currentPromo: update});
		
		console.log(this.state.currentPromo);
	}
	saveConfig() {
		let token = localStorage.getItem("token");
		showMessage("Saving Promotion...");
		var promo = this.state.currentPromo;
		// delete promo.formType;
		var params = {
			headers: {
				"authorization": "Bearer " + token,
				"Content-Type": "application/json",
			},
			body: JSON.stringify(promo),
			method: "POST",
		}
		
		fetch(PROMO_URLS.API+"promo", params)
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('Something went wrong ...'); }
		})
		.then(data => {
			hideMessage(data.success);
			this.load();
		})
		.catch(error => console.log(error));

	}
	updateEventState(value, index, field, widgetId) {
		// console.log(value+": "+index+", "+field+", "+widgetId);
		var update = this.state.currentWidgets
		for (var i = update.length - 1; i >= 0; i--) {
			if ( update[i].widgetId === widgetId ) {
				
				var events = update[i].events;
				for (var x = 0; x <= events.length - 1; x++) {
					if(x === index) {
						events[x][field] = value 
					}
				}
			}
		}
		console.log(this.state.currentWidgets);
	}
	addElement(widgetId, type) {
		var update = this.state.currentWidgets
		for (var i = update.length - 1; i >= 0; i--) {
			if ( update[i].widgetId === widgetId ) {

				if (type === "image") {
					update[i].images.push(
						{
							"size": "",
							"type": "",
							"url": null,
							"widgetId": widgetId
						},
					);
				} else if (type === "text") {
					update[i].texts.push(
						{
							"widgetId": widgetId,
							"type": null,
							"order": 0,
							"text": "",
						},
					);
				}

			}
		}
		this.setState({currentWidgets: update});
	}
	updateImageState(index, widgetId, field) {
		var image = document.querySelectorAll(".images-container .images-"+widgetId+"-"+index)[0]
		// console.log(image);
		
		var value = image.querySelector("select[name='"+field+"']").value;
		
		var update = this.state.currentWidgets
		for (var i = update.length - 1; i >= 0; i--) {
			if ( update[i].widgetId === widgetId ) {
				
				var images = update[i].images;
				for (var x = 0; x <= images.length - 1; x++) {
					if(x === index) {
						images[x][field] = value 
					}
				}
			}
		}
		// console.log(update);
		this.setState({currentWidgets: update});
	}
	deleteElement(id, widgetId, index, type) {
		let token = localStorage.getItem("token");

		var endpoint, params;
		if (type === "image") {
			params = {
				headers: {
					"authorization": "bearer " + token,
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					"imageId": id
				}),
				method: "DELETE",
			}
			endpoint = PROMO_URLS.image;
		} else if (type === "text") {
			params = {
				headers: {
					"authorization": "bearer " + token,
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					"textId": id
				}),
				method: "DELETE",
			}
			endpoint = PROMO_URLS.text;
		}
		fetch(endpoint, params)
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('Something went wrong ...'); }
		})
		.then(data => {
			if (data.success === true) {
				var update = this.state.currentWidgets
				for (var i = update.length - 1; i >= 0; i--) {
					if ( update[i].widgetId === widgetId ) {

						if (type === "image") {
							update[i].images.splice(index, 1);
						} else if (type === "text") {
							update[i].texts.splice(index, 1);
						}

					}
				}
				this.setState({currentWidgets: update});
			} else {
				alert("failed to delete Image ID "+id);
			}
		})
		.catch(error => console.log(error));
	}
	handleImageUpload(widgetId, widgetType, index) {
		let token = localStorage.getItem("token");

		// console.log(widgetId, widgetType, index);
		var imageContainer = document.querySelectorAll("#promo-"+widgetType+"-inputs .tab.active .images-"+widgetId+"-"+index)[0];
		// console.log(imageContainer)
		var fileInput = imageContainer.querySelectorAll("input#"+widgetType+"-img-"+index)[0];
		// console.log(fileInput)

		var imagesBody = new FormData();
		var file = fileInput.files[0];

		var type;
		var imagesParams = {
			headers: {
				"authorization": "bearer " + token,
			},
			body: imagesBody,
			method: "POST",
		}

		if (file.size > 1000000) {
			if( window.confirm("file size over 1MB, are you sure you want to continue?") ) {
				imageContainer.querySelectorAll("button")[0].innerText = "Uploading Image...";
				// continue on with funtion and upload
				imagesBody.append('image', file);
				type = imageContainer.querySelectorAll("#type")[0].value;
				
				// fetch function for each image... sloppy but should work...
				fetch(PROMO_URLS.image+widgetId+"/"+type, imagesParams)
				.then(response => {
					if (response.ok) { return response.json(); } 
					else { throw new Error('Something went wrong ...'); }
				})
				.then(data => {
					console.log(data);
					var update = this.state.currentWidgets
					for (var i = update.length - 1; i >= 0; i--) {
						if ( update[i].widgetId === widgetId ) {
							var images = update[i].images;
							for (var x = 0; x <= images.length - 1; x++) {
								if(x === index) {
									images[x]["imageId"] = data.result.imageId;
									images[x]["type"] = data.result.type;
									images[x]["url"] = data.result.url;
									images[x]["widgetId"] = data.result.widgetId;
								}
							}
						}
					}
					this.setState({currentWidgets: update});
				})
				.catch(error => console.log(error));
			} else {
				// do nothing and exit function...
			}
		} else {
			imageContainer.querySelectorAll("button")[0].innerText = "Uploading Image...";
			imagesBody.append('image', file);

			type = imageContainer.querySelectorAll("#type")[0].value;
			
			// fetch function for each image... sloppy but should work...
			fetch(PROMO_URLS.image+widgetId+"/"+type, imagesParams)
			.then(response => {
				if (response.ok) { return response.json(); } 
				else { throw new Error('Something went wrong ...'); }
			})
			.then(data => {
				console.log(data);
				var update = this.state.currentWidgets
				for (var i = update.length - 1; i >= 0; i--) {
					if ( update[i].widgetId === widgetId ) {
						var images = update[i].images;
						for (var x = 0; x <= images.length - 1; x++) {
							if(x === index) {
								images[x]["imageId"] = data.result.imageId;
								images[x]["type"] = data.result.type;
								images[x]["url"] = data.result.url;
								images[x]["widgetId"] = data.result.widgetId;
							}
						}
					}
				}
				this.setState({currentWidgets: update});
			})
			.catch(error => console.log(error));
		}
	}
	
	getPromoReport(clientCode) {
		let token = localStorage.getItem("token");
		
		fetch(PROMO_URLS.listAllPromotions+"/all/"+clientCode, basicGET(token))
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('Something went wrong ...'); }
		})
		.then(data => {
			// console.log(data);
			data.result = data.result.sort((a, b) => (a["startDate"] < b["startDate"]) ? 1 : -1);
			this.setState({"promoReport": data});
		})
		.catch(error => console.log(error));
	}






	

	render() {
		const { promos, clients, clientList, currentPromo, currentWidgets, couponTemplates, promoReport } = this.state;

		return (
			<div className="columns">
				<Reload click={this.loadPromotions} />
				
				<div className="column left-column" id="promotions-column">
					<section className="section">
						<NewPromotionForm addPromotion={this.addPromotion} />
						<DuplicatePromoForm promoDuplicate={this.promoDuplicate} />
					</section>
					<section className="section">
						<h3>All Promotions: {promos.length ? (promos.length) : ("Loading...")}</h3>
						<div id="check-client-button">
							<button className="button icon" onClick={() => showPopup("check-client-form")}>
								<span>Check Client Promos</span>
							</button>
						</div>
						<SearchForm page="promotions" />
					</section>
					<div className="list-tabs">
						<div className="tab active" id="promo-tab-1" onClick={() => toggleStatus("all", "promo-tab-1", "promotions")}>All</div>
						<div className="tab" id="promo-tab-2" onClick={() => toggleStatus("up", "promo-tab-2", "promotions")}>Active</div>
						<div className="tab" id="promo-tab-3" onClick={() => toggleStatus("paused", "promo-tab-3", "promotions")}>Scheduled</div>
						<div className="tab" id="promo-tab-4" onClick={() => toggleStatus("down", "promo-tab-4", "promotions")}>Ended</div>
						<div className="tab new" onClick={() => showPopup("addPromoForm")}>New Promotion</div>
					</div>
					<div className="list-label">PROMO NAME <span className="uptime-label">Status</span></div>

					<ResultList
						page={"promotions"}
						data={promos}
						load={this.load}
					/>

				</div>
				<div className="column profile-column" id="promotion-profile-column">

					<CheckClientPromos clients={clientList} getReport={this.getPromoReport} report={promoReport} />

					<div className="profile">
						<div className="profile-header">
							<h3 className="profile-name">{currentPromo.name}</h3>
							<CloseProfile
								reset={() => this.resetProfile()}
								duplicate={() => showPopup("dupePromoForm")}
							/>
						</div>
						<div className="profile-form">
{/*CONFIG*/}
{/*work on moving all of these widgets to their own files....*/}
							<div className="input-group">
								<AccordianTitle title={"Promo Configuration"} />
								<div className="accordian-body">
									<ActionTabs 
										handleSave={() => this.saveConfig()}
									/>
									<div id="promo-info" className="inputs">
										<input type="hidden" name="promoId" placeholder="promoId" defaultValue={currentPromo.promoId} hidden="" className="hidden" />
										<input type="hidden" name="manufacturerCode" placeholder="manufacturerCode" defaultValue={currentPromo.manufacturerCode} hidden="" className="hidden" />
										<InputRow label="Name" type="text" value={currentPromo.name} property="name" onChange={(e) => this.updateConfigState("name", e.target.value)} />
										<InputRow label="promoCode" type="text" value={currentPromo.promoCode} property="promoCode" disabled />

										<InputRow label="Start Date" type="date" value={currentPromo.startDate} property="startDate" onChange={(e) => this.updateConfigState("startDate", e.target.value)} />
										<InputRow label="End Date" type="date" value={currentPromo.endDate} property="endDate" onChange={(e) => this.updateConfigState("endDate", e.target.value)} />

										<InputRow
											label="Promotion Priority" type="select" value={currentPromo.priority} property="priority" id="priority"
											onChange={(e) => this.updateConfigState("priority", e.target.value)}
											description={"if multiple promotions active for same client, set a priority to help determine which promo assets should take priority where more than one asset qualifies to be visible, but only one should be visible."}
											options={[
												{"name": "0","value": "0"},
												{"name": "1","value": "1"},
												{"name": "2","value": "2"},
												{"name": "3","value": "3"},
												{"name": "4","value": "4"},
												{"name": "5","value": "5"},
												{"name": "6","value": "6"},
												{"name": "7","value": "7"},
												{"name": "8","value": "8"},
												{"name": "9","value": "9"}
											]}
										/>

										<InputRow
											label="Is This A Rug.Shop Promotion" type="checkbox" value={currentPromo.rugShop} property="rugShop"
											onChange={(e) => this.updateConfigState("rugShop", e.target.checked)}
											description={"All slides/banners/buttons/etc. will link to the customers rugs.shop affiliate automatically"}
										/>
										
										<InputRow
											onChange={(e) => this.updateConfigState("franchiseName", e.target.value)}
											label="Is this promo Franchise Specific?"
											type="select"
											value={currentPromo.franchiseName}
											property="franchiseName"
											id="franchiseName"
											options={franchiseList}
											description={"limits the promotion to only clients in the chosen franchise"}
										/>
										{(currentPromo.franchiseName === "floorsToCeiling")&&(
											<InputRow
												label="is this promo Category Specific?" type="select" value={currentPromo.category} property="category" id="category"
												onChange={(e) => this.updateConfigState("category", e.target.value)}
												hideSelectOption="false"
												options={[
													{"name": "Flooring", "value": "flooring"},
													{"name": "Kitchen & Bath", "value": "kitchenBath"},
													{"name": "Window Treatments", "value": "windowTreatment"},
												]}
												description={"this will assign a Banner Block to this category page"}
											/>
										)}
										
										<InputRow
											label="Show 'Get Coupon' Button" type="select" value={currentPromo.getCoupon} property="getCoupon" id="getCoupon"
											onChange={(e) => this.updateConfigState("getCoupon", e.target.value)}
											hideSelectOption="true"
											options={[
												{"name": "Hide Button", "value": false},
												{"name": "Show Button", "value": true},
											]}
											description={"Button will link to the /flooring-coupon page automatically"}
										/>
										<div className="input-row">
											<label htmlFor="brandList">Is this promo Brand Specific?</label>
											<div>
												<input type="text" name="brandList" placeholder="brand 1, brand 2, brand 3" defaultValue={currentPromo.brandList}  onChange={(e) => this.updateConfigState("brandList", e.target.value)} />
												<p>Limit the 'Get Coupon' button to just these brands...</p>
												<p>comma separated list, all lower case</p>
												<p>leave empty for All brands</p>
											</div>
										</div>

										

										<InputRow
											label="Form Name For Coupon Submissions" type="select" value={currentPromo.formName} property="formName" id="formName"
											onChange={(e) => this.updateConfigState("formName", e.target.value)}
											options={(currentPromo.franchiseName === "floorsToCeiling")?(promoFloorToCeilingFormList):(promoVelocityFormList)}
										/>
										<InputRow label="Form Title" type="text" value={currentPromo.formTitle} property="formTitle" onChange={(e) => this.updateConfigState("formTitle", e.target.value)} />
										<InputRow label="Form Type" type="text" value={currentPromo.formType} property="formType" onChange={(e) => this.updateConfigState("formType", e.target.value)} description={"The form name, reversed, with a dash... Shaw Coupon => coupon-shaw"} />
										<InputRow label="Advertising" type="text" value={currentPromo.advertising} property="advertising" onChange={(e) => this.updateConfigState("advertising", e.target.value)}/>

										<InputRow
											label="Testing" type="checkbox" value={currentPromo.testing} property="testing"
											onChange={(e) => this.updateConfigState("testing", e.target.checked)}
											description={"Send all messages to the test addresses or SMS numbers configured below"}
										/>

										<InputRow label="Test Addresses" type="text" value={currentPromo.testEmail} property="testEmail" onChange={(e) => this.updateConfigState("testEmail", e.target.value)}/>
										<InputRow label="Test SMS numbers" type="text" value={currentPromo.testPhone} property="testPhone" onChange={(e) => this.updateConfigState("testPhone", e.target.value)}/>
									</div>
								</div>
							</div>
{/*EMAIL TEMPLATES*/}
							<div className="input-group">
								<AccordianTitle title={"Coupon Emails"} />
								<div className="accordian-body">
									<ActionTabs
										id={"promo-email"}
										tabs={currentWidgets.filter(widget => { return widget.type === "email" })}
										handleAdd={() => this.addWidget("email")}
										handleSave={() => this.saveWidget("save", "email")}
										handleDelete={() => this.saveWidget("delete", "email")}
									/>
								{/*MAP the email inputs*/}
									<div id="promo-email-inputs" className="inputs">
										{currentWidgets.map((widget) => (widget.type === "email") &&
											( <React.Fragment key={widget.widgetId}>

												<div id={"promo-email-"+widget.widgetId} className={"tab promo-email-"+widget.widgetId}>
													<input type="hidden" name="widgetId" defaultValue={widget.widgetId} className="hidden" />
													<input type="hidden" name="promoId" defaultValue={widget.promoId} className="hidden" />
													<input type="hidden" name="type" defaultValue={widget.type} className="hidden" />
													<InputRow label="Name" type="text" value={widget.name} property="name" />
													<InputRow label="Coupon Value ($)" type="number" value={widget.couponValue} property="couponValue" />

													<h4>Campaign Events</h4>
													
													<div className="event-list">
														{(widget.events && widget.events.length > 0) && (
															widget.events.map((event, index) =>
																( <React.Fragment key={index}>
																	
																	<div className={"event event-"+index}>
																		<button className="button" onClick={() => this.handleEvent("remove", widget.widgetId, index)}><i className="far fa-trash-alt icon"></i></button>
																		<InputRow label="Event ID (for email testing)" type="text" value={event.eventId} property="eventId" disabled />
																		<InputRow label="Event Email Template" type="select" value={event.template} property="template" options={couponTemplates} onChange={(e) => this.updateEventState(e.target.value, index, "template", widget.widgetId)} />
																		{/*<InputRow label="Event Email Template ID" type="text" value={event.template} property="template" onChange={(e) => this.updateEventState(e.target.value, index, "template", widget.widgetId)} />*/}
																		<InputRow label="Hours From Lead Submission" type="text" value={event.hours} property="hours" onChange={(e) => this.updateEventState(e.target.value, index, "hours", widget.widgetId)} />
																		<InputRow label="Days From Lead Submission" type="text" value={event.days} property="days" onChange={(e) => this.updateEventState(e.target.value, index, "days", widget.widgetId)} />
																	</div>
																				
																</React.Fragment> )
															)
														)}
													</div>
													<button className="button" onClick={() => this.handleEvent("add", widget.widgetId)}>Add Event <i className="fas fa-plus"></i></button>
													
													<ClientAssignmentList
														group="email"
														params={[
															{"label": "All", "key": "velocity", "value": true},
															{"label": "Velocity Lite", "key": "servicePackage", "value": "lite"},
															{"label": "Velocity Prime", "key": "servicePackage", "value": "prime"},
															{"label": "Velocity Premium", "key": "servicePackage", "value": "premium"},
															{"label": "Velocity Platinum", "key": "servicePackage", "value": "platinum"},
															{"label": "ELA", "key": "ela", "value": true},
															{"label": "Omnify", "key": "omnify", "value": true},
															{"label": "Legacy / Franchise", "key": "velocity", "value": false},
														]}
														clients={clients}
														widget={widget}
														assign={this.assign}
													/>
												</div>

											</React.Fragment> )
										)}
									</div>
								</div>
							</div>

{/*SLIDES*/}
							<div className="input-group">
								<div className="accordian-title" onClick={accordian}>
									<h4>Slides</h4>
								</div>
								<div className="accordian-body">
									<ActionTabs
										id={"promo-slide"}
										tabs={currentWidgets.filter(widget => { return widget.type === "slide" })}
										handleAdd={() => this.addWidget("slide")}
										handleSave={() => this.saveWidget("save", "slide")}
										handleDelete={() => this.saveWidget("delete", "slide")}
									/>
								{/*MAP the slide inputs*/}
									<div id="promo-slide-inputs" className="inputs">
										{currentWidgets.map((widget, type) => (widget.type === "slide") &&
											( <React.Fragment key={widget.widgetId}>

												<div id={"promo-slide-"+widget.widgetId} className={"tab promo-slide-"+widget.widgetId}>
													<input type="hidden" name="widgetId" defaultValue={widget.widgetId} className="hidden" />
													<input type="hidden" name="promoId" defaultValue={widget.promoId} className="hidden" />
													<input type="hidden" name="type" defaultValue={widget.type} className="hidden" />
													
													<InputRow label="Name" type="text" value={widget.name} property="name" />
													<InputRow label="Title" type="text" value={widget.title} property="title" />
													<InputRow label="Destination Link" type="text" value={widget.link} property="link" />
													<InputRow label="Position" type="text" value={widget.order} property="order" />
													<InputRow label="Do Not Show On Homepage" type="checkbox" value={widget.doNotShowOnHomepage} property="doNotShowOnHomepage" />


													<h4 className={"load-images-"+widget.widgetId}>images</h4>
													<button onClick={() => this.addElement(widget.widgetId, "image")} className="button">
														Add images <i className="fas fa-plus"></i>
													</button>

													<div className="images-container">
														{widget.images.map((image, index) =>
															<div className={"images images-"+widget.widgetId+"-"+index} key={index} >
																<input type="hidden" name="widgetId" placeholder="widgetId" defaultValue={image.widgetId} className="hidden" />
																{ (image.imageId) ? (
																	<React.Fragment>
																		<input type="hidden" name="imageId" placeholder="imageId" defaultValue={image.imageId} className="hidden" />
																		<div className="input-row">
																			<label htmlFor="url">Image</label>
																			<div>
																				<div className="delete-img"><i className="fas fa-times icon" onClick={() => this.deleteElement(image.imageId, widget.widgetId, index, "image")}></i></div>
																				<img src={"//"+image.url} className="promo-image" alt={image.type} />
																			</div>
																		</div>
																	</React.Fragment>
																) : (
																	<div className="input-row">
																		<label htmlFor="url">Image</label>
																		<div>
																			<img src="" alt="" />
																			<input type="file" name="url" placeholder="url" defaultValue="" className="promo-image" id={widget.type+"-img-"+index} />
																			<span>Max Image Size is 1MB, Please ensure all images are optimized and web ready.</span>
																		</div>
																	</div>
																)}

																<InputRow
																	label="Type" type="select" value={image.type} property="type" id="type" onChange={() => this.updateImageState(index, widget.widgetId, "type")}
																	options={[
																		{"name": "Background","value": "background"},
																		{"name": "Sale Graphic","value": "graphic"}
																	]}
																/>
																{ (!image.imageId) && (
																	<button onClick={() => this.handleImageUpload(widget.widgetId, widget.type, index)} className="button">
																		Upload <i className="fas fa-upload"></i>
																	</button>
																)}
															</div>
														)}
													</div>

													<ClientAssignmentList
														group="email"
														params={[
															{"label": "All", "key": "velocity", "value": true},
															{"label": "Velocity Lite", "key": "servicePackage", "value": "lite"},
															{"label": "Velocity Prime", "key": "servicePackage", "value": "prime"},
															{"label": "Velocity Premium", "key": "servicePackage", "value": "premium"},
															{"label": "Velocity Platinum", "key": "servicePackage", "value": "platinum"},
															{"label": "ELA", "key": "ela", "value": true},
															{"label": "Omnify", "key": "omnify", "value": true},
															{"label": "Legacy / Franchise", "key": "velocity", "value": false},
														]}
														clients={clients}
														widget={widget}
														assign={this.assign}
													/>
												</div>

											</React.Fragment> )
										)}
									</div>
								</div>
							</div>
{/*MESSAGES*/}
							<div className="input-group">
								<div className="accordian-title" onClick={accordian}>
									<h4>Message Blocks</h4>
								</div>
								<div className="accordian-body">
									<ActionTabs
										id={"promo-message"}
										tabs={currentWidgets.filter(widget => { return widget.type === "message" })}
										handleAdd={() => this.addWidget("message")}
										handleSave={() => this.saveWidget("save", "message")}
										handleDelete={() => this.saveWidget("delete", "message")}
									/>
									<div id="promo-message-inputs" className="inputs">
										{currentWidgets.map((widget, type) => (widget.type === "message") &&
											( <React.Fragment key={widget.widgetId}>

												<div id={"promo-message-"+widget.widgetId} className={"tab promo-message-"+widget.widgetId}>
													<input type="hidden" name="widgetId" defaultValue={widget.widgetId} className="hidden" />
													<input type="hidden" name="promoId" defaultValue={widget.promoId} className="hidden" />
													<input type="hidden" name="type" defaultValue={widget.type} className="hidden" />
													
													<InputRow label="Name" type="text" value={widget.name} property="name" />
													<InputRow label="Color Code" type="text" value={widget.colorCode} property="colorCode" />

													<h4 className="load-texts-306">texts</h4>
													<div className="texts-container">
														{widget.texts.map((text, index) =>
															<div className={"texts texts-"+widget.widgetId} key={text.textId} >
																<input type="hidden" name="textId" placeholder="textId" defaultValue={text.textId} className="hidden" />
																<input type="hidden" name="widgetId" placeholder="widgetId" defaultValue={text.widgetId} className="hidden" />
																<div className="input-row">
																	<label htmlFor="url">Image</label>
																	<div>
																		<div className="delete-img"><i className="fas fa-times icon" onClick={() => this.deleteElement(text.textId, widget.widgetId, index, "text")}></i></div>
																	</div>
																</div>
																<InputRow
																	label="Type" type="select" value={text.type} property="type" id="type"
																	options={[
																		{"name": "Copy","value": "copy"},
																		{"name": "Button","value": "button"}
																	]}
																/>
																<InputRow label="Text" type="textarea" value={text.text} property="text" />
															</div>
														)}
													</div>
													<button onClick={() => this.addElement(widget.widgetId, "text")} className="button">
														Add Texts <i className="fas fa-plus"></i>
													</button>
													<ClientAssignmentList
														group="email"
														params={[
															{"label": "All", "key": "velocity", "value": true},
															{"label": "Velocity Lite", "key": "servicePackage", "value": "lite"},
															{"label": "Velocity Prime", "key": "servicePackage", "value": "prime"},
															{"label": "Velocity Premium", "key": "servicePackage", "value": "premium"},
															{"label": "Velocity Platinum", "key": "servicePackage", "value": "platinum"},
															{"label": "ELA", "key": "ela", "value": true},
															{"label": "Omnify", "key": "omnify", "value": true},
															{"label": "Legacy / Franchise", "key": "velocity", "value": false},
														]}
														clients={clients}
														widget={widget}
														assign={this.assign}
													/>
												</div>
											</React.Fragment> )
										)}
									</div>
								</div>
							</div>
{/*POPUP BLOCKS*/}
							<div className="input-group">
								<div className="accordian-title" onClick={accordian}>
									<h4>Popup Blocks</h4>
								</div>
								<div className="accordian-body">
									<ActionTabs
										id={"promo-popup"}
										tabs={currentWidgets.filter(widget => { return widget.type === "popup" })}
										handleAdd={() => this.addWidget("popup")}
										handleSave={() => this.saveWidget("save", "popup")}
										handleDelete={() => this.saveWidget("delete", "popup")}
									/>
									<div id="promo-popup-inputs" className="inputs">
										{currentWidgets.map((widget, type) => (widget.type === "popup") &&
											( <React.Fragment key={widget.widgetId}>

												<div id={"promo-popup-"+widget.widgetId} className={"tab promo-popup-"+widget.widgetId}>
													<input type="hidden" name="widgetId" defaultValue={widget.widgetId} className="hidden" />
													<input type="hidden" name="promoId" defaultValue={widget.promoId} className="hidden" />
													<input type="hidden" name="type" defaultValue={widget.type} className="hidden" />
													<InputRow label="Name" type="text" value={widget.name} property="name" />

													<h4 className={"load-images-"+widget.widgetId}>images</h4>
													<button onClick={() => this.addElement(widget.widgetId, "image")} className="button">
														Add images <i className="fas fa-plus"></i>
													</button>
													<div className="images-container">
														{widget.images.map((image, index) =>
															<div className={"images images-"+widget.widgetId+"-"+index} key={index} >
																<input type="hidden" name="widgetId" placeholder="widgetId" defaultValue={image.widgetId} className="hidden" />
																<input type="hidden" name="type" id="type" placeholder="type" defaultValue="graphic" />
																{ (image.imageId) ? (
																	<React.Fragment>
																		<input type="hidden" name="imageId" placeholder="imageId" defaultValue={image.imageId} className="hidden" />
																		<div className="input-row">
																			<label htmlFor="url">Image</label>
																			<div>
																				<div className="delete-img"><i className="fas fa-times icon" onClick={() => this.deleteElement(image.imageId, widget.widgetId, index, "image")}></i></div>
																				<img src={"//"+image.url} className="promo-image" alt={image.type} />
																			</div>
																		</div>
																	</React.Fragment>
																) : (
																	<div className="input-row">
																		<label htmlFor="url">Image</label>
																		<div>
																			<img src="" alt="" />
																			<input type="file" name="url" placeholder="url" defaultValue="" className="promo-image" id={widget.type+"-img-"+index} />
																			<span>Max Image Size is 1MB, Please ensure all images are optimized and web ready.</span>
																		</div>
																	</div>
																)}
																{ (!image.imageId) && (
																	<button onClick={() => this.handleImageUpload(widget.widgetId, widget.type, index)} className="button">
																		Upload <i className="fas fa-upload"></i>
																	</button>
																)}
															</div>
														)}
													</div>
													<ClientAssignmentList
														group="email"
														params={[
															{"label": "All", "key": "velocity", "value": true},
															{"label": "Velocity Lite", "key": "servicePackage", "value": "lite"},
															{"label": "Velocity Prime", "key": "servicePackage", "value": "prime"},
															{"label": "Velocity Premium", "key": "servicePackage", "value": "premium"},
															{"label": "Velocity Platinum", "key": "servicePackage", "value": "platinum"},
															{"label": "ELA", "key": "ela", "value": true},
															{"label": "Omnify", "key": "omnify", "value": true},
															{"label": "Legacy / Franchise", "key": "velocity", "value": false},
														]}
														clients={clients}
														widget={widget}
														assign={this.assign}
													/>
												</div>
											</React.Fragment> )
										)}
									</div>
								</div>
							</div>
{/*BANNER BLOCKS*/}
							<div className="input-group">
								<div className="accordian-title" onClick={accordian}>
									<h4>Banner Blocks</h4>
								</div>
								<div className="accordian-body">
									<ActionTabs
										id={"promo-banner"}
										tabs={currentWidgets.filter(widget => { return widget.type === "banner" })}
										handleAdd={() => this.addWidget("banner")}
										handleSave={() => this.saveWidget("save", "banner")}
										handleDelete={() => this.saveWidget("delete", "banner")}
									/>
									<div id="promo-banner-inputs" className="inputs">
										{currentWidgets.map((widget, type) => (widget.type === "banner") &&
											( <React.Fragment key={widget.widgetId}>

												<div id={"promo-banner-"+widget.widgetId} className={"tab promo-banner-"+widget.widgetId}>
													<input type="hidden" name="widgetId" defaultValue={widget.widgetId} className="hidden" />
													<input type="hidden" name="promoId" defaultValue={widget.promoId} className="hidden" />
													<input type="hidden" name="type" defaultValue={widget.type} className="hidden" />
													
													<InputRow label="Name" type="text" value={widget.name} property="name" />
													<InputRow label="Destination Link" type="text" value={widget.link} property="link" />

													<h4 className={"load-images-"+widget.widgetId}>images</h4>
													<button onClick={() => this.addElement(widget.widgetId, "image")} className="button">
														Add images <i className="fas fa-plus"></i>
													</button>
													<div className="images-container">
														{widget.images.map((image, index) =>
															<div className={"images images-"+widget.widgetId+"-"+index} key={index} >
																<input type="hidden" name="widgetId" placeholder="widgetId" defaultValue={image.widgetId} className="hidden" />
																{ (image.imageId) ? (
																	<React.Fragment>
																		<input type="hidden" name="imageId" placeholder="imageId" defaultValue={image.imageId} className="hidden" />
																		<div className="input-row">
																			<label htmlFor="url">Image</label>
																			<div>
																				<div className="delete-img"><i className="fas fa-times icon" onClick={() => this.deleteElement(image.imageId, widget.widgetId, index, "image")}></i></div>
																				<img src={"//"+image.url} className="promo-image" alt={image.type} />
																			</div>
																		</div>
																	</React.Fragment>
																) : (
																	<div className="input-row">
																		<label htmlFor="url">Image</label>
																		<div>
																			<img src="" alt="" />
																			<input type="file" name="url" placeholder="url" defaultValue="" className="promo-image" id={widget.type+"-img-"+index} />
																			<span>Max Image Size is 1MB, Please ensure all images are optimized and web ready.</span>
																		</div>
																	</div>
																)}
																<InputRow
																	label="Type" type="select" value={image.type} property="type" id="type" onChange={() => this.updateImageState(index, widget.widgetId, "type")}
																	options={[
																		{"name": "Desktop Graphic","value": "desktop"},
																		{"name": "Mobile Graphic","value": "mobile"}
																	]}
																/>
																{ (!image.imageId) && (
																	<button onClick={() => this.handleImageUpload(widget.widgetId, widget.type, index)} className="button">
																		Upload <i className="fas fa-upload"></i>
																	</button>
																)}
															</div>
														)}
													</div>
													<ClientAssignmentList
														group="email"
														params={[
															{"label": "All", "key": "velocity", "value": true},
															{"label": "Velocity Lite", "key": "servicePackage", "value": "lite"},
															{"label": "Velocity Prime", "key": "servicePackage", "value": "prime"},
															{"label": "Velocity Premium", "key": "servicePackage", "value": "premium"},
															{"label": "Velocity Platinum", "key": "servicePackage", "value": "platinum"},
															{"label": "ELA", "key": "ela", "value": true},
															{"label": "Omnify", "key": "omnify", "value": true},
															{"label": "Legacy / Franchise", "key": "velocity", "value": false},
														]}
														clients={clients}
														widget={widget}
														assign={this.assign}
													/>
												</div>
											</React.Fragment> )
										)}
									</div>
								</div>
							</div>
{/*LANDING PAGE*/}
							<div className="input-group">
								<div className="accordian-title" onClick={accordian}>
									<h4>Promotion Landing Pages</h4>
								</div>
								<div className="accordian-body">
									<ActionTabs
										id={"promo-landing"}
										tabs={currentWidgets.filter(widget => { return widget.type === "landing" })}
										handleAdd={() => this.addWidget("landing")}
										handleSave={() => this.saveWidget("save", "landing")}
										handleDelete={() => this.saveWidget("delete", "landing")}
									/>
									<div id="promo-landing-inputs" className="inputs">
										{currentWidgets.map((widget, type) => (widget.type === "landing") &&
											( <React.Fragment key={widget.widgetId}>

												<div id={"promo-landing-"+widget.widgetId} className={"tab promo-landing-"+widget.widgetId}>
													<input type="hidden" name="widgetId" defaultValue={widget.widgetId} className="hidden" />
													<input type="hidden" name="promoId" defaultValue={widget.promoId} className="hidden" />
													<input type="hidden" name="type" value="landing" className="hidden" />
													<InputRow label="Name" type="text" value={widget.name} property="name" />

													<h4 className={"load-images-"+widget.widgetId}>images</h4>
													<button onClick={() => this.addElement(widget.widgetId, "image")} className="button">
														Add images <i className="fas fa-plus"></i>
													</button>
													<div className="images-container">
														{widget.images.map((image, index) =>
															<div className={"images images-"+widget.widgetId+"-"+index} key={index} >
																<input type="hidden" name="widgetId" placeholder="widgetId" defaultValue={image.widgetId} className="hidden" />
																{ (image.imageId) ? (
																	<React.Fragment>
																		<input type="hidden" name="imageId" placeholder="imageId" defaultValue={image.imageId} className="hidden" />
																		<div className="input-row">
																			<label htmlFor="url">Image</label>
																			<div>
																				<div className="delete-img"><i className="fas fa-times icon" onClick={() => this.deleteElement(image.imageId, widget.widgetId, index, "image")}></i></div>
																				<img src={"//"+image.url} className="promo-image" alt={image.type} />
																			</div>
																		</div>
																	</React.Fragment>
																) : (
																	<div className="input-row">
																		<label htmlFor="url">Image</label>
																		<div>
																			<img src="" alt="" />
																			<input type="file" name="url" placeholder="url" defaultValue="" className="promo-image" id={widget.type+"-img-"+index} />
																			<span>Max Image Size is 1MB, Please ensure all images are optimized and web ready.</span>
																		</div>
																	</div>
																)}
																<InputRow
																	label="Type" type="select" value={image.type} property="type" id="type" onChange={() => this.updateImageState(index, widget.widgetId, "type")}
																	options={[
																		{"name": "Background", "value": "background"},
																		{"name": "Graphic", "value": "graphic"},
																		{"name": "Mobile Graphic", "value": "mobile"},
																		{"name": "Graphic for Print", "value": "print"}
																	]}
																/>
																{ (!image.imageId) && (
																	<button onClick={() => this.handleImageUpload(widget.widgetId, widget.type, index)} className="button">
																		Upload <i className="fas fa-upload"></i>
																	</button>
																)}
															</div>
														)}
													</div>

													<h4 className="load-texts-306">texts</h4>
													<div className="texts-container">
														{widget.texts.map(text =>
															<div className={"texts texts-"+widget.widgetId} key={text.textId} >
																<input type="hidden" name="textId" placeholder="textId" defaultValue={text.textId} className="hidden" />
																<input type="hidden" name="widgetId" placeholder="widgetId" defaultValue={text.widgetId} className="hidden" />
																<InputRow
																	label="Type" type="select" value={text.type} property="type" id="type"
																	options={[
																		{"name": "Copy", "value": "copy"},
																		{"name": "Heading", "value": "heading"},
																		{"name": "Sub Heading", "value": "subheading"}
																	]}
																/>
																<InputRow label="Text" type="textarea" value={text.text} property="text" />
															</div>
														)}
													</div>
													<button onClick={() => this.addElement(widget.widgetId, "text")} className="button">
														Add Texts <i className="fas fa-plus"></i>
													</button>
													<ClientAssignmentList
														group="email"
														params={[
															{"label": "All", "key": "velocity", "value": true},
															{"label": "Velocity Lite", "key": "servicePackage", "value": "lite"},
															{"label": "Velocity Prime", "key": "servicePackage", "value": "prime"},
															{"label": "Velocity Premium", "key": "servicePackage", "value": "premium"},
															{"label": "Velocity Platinum", "key": "servicePackage", "value": "platinum"},
															{"label": "ELA", "key": "ela", "value": true},
															{"label": "Omnify", "key": "omnify", "value": true},
															{"label": "Legacy / Franchise", "key": "velocity", "value": false},
														]}
														clients={clients}
														widget={widget}
														assign={this.assign}
													/>
												</div>
											</React.Fragment> )
										)}
									</div>
								</div>
							</div>
{/*THANK YOU PAGE*/}
							<div className="input-group">
								<div className="accordian-title" onClick={accordian}>
									<h4>Thank You Pages</h4>
								</div>
								<div className="accordian-body">
									<p><em>This tool will be used exclusively for the shaw fall sale to start. This will have no use for any other promotion until notified otherwise.</em></p>
									<ActionTabs
										id={"promo-thanks"}
										tabs={currentWidgets.filter(widget => { return widget.type === "thanks" })}
										handleAdd={() => this.addWidget("thanks")}
										handleSave={() => this.saveWidget("save", "thanks")}
										handleDelete={() => this.saveWidget("delete", "thanks")}
									/>
									<div id="promo-thanks-inputs" className="inputs">
										{currentWidgets.map((widget, type) => (widget.type === "thanks") &&
											( <React.Fragment key={widget.widgetId}>
												<div id={"promo-thanks-"+widget.widgetId} className={"tab promo-thanks-"+widget.widgetId}>
													<input type="hidden" name="widgetId" defaultValue={widget.widgetId} className="hidden" />
													<input type="hidden" name="promoId" defaultValue={widget.promoId} className="hidden" />
													<input type="hidden" name="type" value="thanks" className="hidden" />
													
													<InputRow label="Name" type="text" value={widget.name} property="name" />

													<h4 className={"load-images-"+widget.widgetId}>images</h4>
													<button onClick={() => this.addElement(widget.widgetId, "image")} className="button">
														Add images <i className="fas fa-plus"></i>
													</button>

													<div className="images-container">
														{widget.images.map((image, index) =>
															<div className={"images images-"+widget.widgetId+"-"+index} key={index} >
																<input type="hidden" name="widgetId" placeholder="widgetId" defaultValue={image.widgetId} className="hidden" />
																{ (image.imageId) ? (
																	<React.Fragment>
																		<input type="hidden" name="imageId" placeholder="imageId" defaultValue={image.imageId} className="hidden" />
																		<div className="input-row">
																			<label htmlFor="url">Image</label>
																			<div>
																				<div className="delete-img"><i className="fas fa-times icon" onClick={() => this.deleteElement(image.imageId, widget.widgetId, index, "image")}></i></div>
																				<img src={"//"+image.url} className="promo-image" alt={image.type} />
																			</div>
																		</div>
																	</React.Fragment>
																) : (
																	<div className="input-row">
																		<label htmlFor="url">Image</label>
																		<div>
																			<img src="" alt="" />
																			<input type="file" name="url" placeholder="url" defaultValue="" className="promo-image" id={widget.type+"-img-"+index} />
																			<span>Max Image Size is 1MB, Please ensure all images are optimized and web ready.</span>
																		</div>
																	</div>
																)}
																<InputRow
																	label="Type" type="select" value={image.type} property="type" id="type" onChange={() => this.updateImageState(index, widget.widgetId, "type")}
																	options={[
																		{"name": "Desktop Graphic", "value": "graphic"},
																		{"name": "Mobile Graphic", "value": "mobile"}
																	]}
																/>
																{ (!image.imageId) && (
																	<button onClick={() => this.handleImageUpload(widget.widgetId, widget.type, index)} className="button">
																		Upload <i className="fas fa-upload"></i>
																	</button>
																)}
															</div>
														)}
													</div>

													<h4 className="load-texts-306">texts</h4>
													<div className="texts-container">
														{widget.texts.map(text =>
															<div className={"texts texts-"+widget.widgetId} key={text.textId} >
																<input type="hidden" name="textId" placeholder="textId" defaultValue={text.textId} className="hidden" />
																<input type="hidden" name="widgetId" placeholder="widgetId" defaultValue={text.widgetId} className="hidden" />
																<InputRow
																	label="Type" type="select" value={text.type} property="type" id="type"
																	options={[
																		{"name": "Copy", "value": "copy"},
																		{"name": "Disclaimer", "value": "disclaimer"}
																	]}
																/>
																<InputRow label="Text" type="textarea" value={text.text} property="text" />
															</div>
														)}
													</div>
													<button onClick={() => this.addElement(widget.widgetId, "text")} className="button">
														Add Texts <i className="fas fa-plus"></i>
													</button>
													<ClientAssignmentList
														group="email"
														params={[
															{"label": "All", "key": "velocity", "value": true},
															{"label": "Velocity Lite", "key": "servicePackage", "value": "lite"},
															{"label": "Velocity Prime", "key": "servicePackage", "value": "prime"},
															{"label": "Velocity Premium", "key": "servicePackage", "value": "premium"},
															{"label": "Velocity Platinum", "key": "servicePackage", "value": "platinum"},
															{"label": "ELA", "key": "ela", "value": true},
															{"label": "Omnify", "key": "omnify", "value": true},
															{"label": "Legacy / Franchise", "key": "velocity", "value": false},
														]}
														clients={clients}
														widget={widget}
														assign={this.assign}
													/>
												</div>
											</React.Fragment> )
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}
export default Promotions;


// WEBPACK FOOTER //
// ./src/component_promotions/Promotions.js